const SourceKeys = {
  publicForm: "public-form",
  marketing: "marketing",
  directsales: "directsales",
  agentsales: "agentsales"
}

export default SourceKeys
